import { adminFetch } from './dataProvider';

export async function deactivateUser(oid: string, reason: string): Promise<void> {
  await adminFetch<void>(`/v1/admin/users/${oid}/deactivate`, {
    method: 'POST',
    body: JSON.stringify({ reason }),
  });
}

export async function reactivateUser(oid: string): Promise<void> {
  await adminFetch<void>(`/v1/admin/users/${oid}/reactivate`, { method: 'POST' });
}
